export default __webpack_public_path__ + "static/media/expensetracker.7fee6351.png";